// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1kyoR","touchList":"_21g6j"};